// Czysta klasyfikacja ceny vs historia 30 dni.
// Używana w deal feedach (homepage), na landingach par i w OG image.
//
// Reguły dobrane "po polsku" — chcemy żeby badge pojawiał się rzadko,
// ale gdy się pojawi, był wiarygodny (nie "okazja!" przy każdej cenie).

export type PriceBadgeKind = "lowest" | "great" | "good" | "high";

export type PriceBadge = {
  kind: PriceBadgeKind;
  label: string;
  /** −18 → 18% taniej niż avg30; +15 → 15% drożej. */
  deltaPct?: number;
  /** Ile dni wstecz mamy w historii (kontekst dla "od X dni"). */
  days?: number;
};

export type PriceHistorySummary = {
  min: number;
  avg: number;
  count: number; // liczba dni z próbkami w okresie
  daysSpan: number; // 30 dla 30-dniowego okna
};

export function classifyPrice(
  current: number,
  hist: PriceHistorySummary | null | undefined,
): PriceBadge | null {
  if (!hist || hist.count < 3 || hist.avg <= 0 || current <= 0) return null;
  const delta = (current - hist.avg) / hist.avg; // dodatnia = drożej
  const pct = Math.round(delta * 100);

  // "Najtaniej od X dni" — bezwzględny zwycięzca (tolerancja 1 zł
  // żeby drobne wahania zaokrągleń nie blokowały badge'a).
  if (current <= hist.min + 1) {
    return {
      kind: "lowest",
      label: `Najtaniej od ${hist.daysSpan} dni`,
      deltaPct: pct,
      days: hist.daysSpan,
    };
  }
  // Świetna okazja: ≥15% taniej niż średnia.
  if (delta <= -0.15) {
    return {
      kind: "great",
      label: `${Math.abs(pct)}% taniej niż zwykle`,
      deltaPct: pct,
    };
  }
  // Niezła cena: 7–15% poniżej średniej.
  if (delta <= -0.07) {
    return {
      kind: "good",
      label: "Dobra cena",
      deltaPct: pct,
    };
  }
  // Wyższa niż zwykle: ≥15% drożej (ostrzeżenie kontekstowe).
  if (delta >= 0.15) {
    return {
      kind: "high",
      label: "Wyższa niż zwykle",
      deltaPct: pct,
    };
  }
  return null;
}
